// ServiziPage.js
import React from 'react';
import {Link} from "react-router-dom";
import './Servizi.css';
import Grid from './Grid';

const ServiziPage = () => {
    return (

    <div className="servizi-container">
        <img src="servizi-bkg.jpg" width='100%'/>

            <Grid />

        </div>
    );
};

export default ServiziPage;